export default __webpack_public_path__ + "static/media/stream.47a9d57e.jpg";